/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchUserTransactionsResponseItem } from './search-user-transactions-response-item';


export interface SearchUserTransactionsResponseItemPagedList { 
    totalCount?: number;
    items?: Array<SearchUserTransactionsResponseItem> | null;
}

